import { render, staticRenderFns } from "./cdn.vue?vue&type=template&id=5989e7f4&scoped=true&"
import script from "./cdn.vue?vue&type=script&lang=js&"
export * from "./cdn.vue?vue&type=script&lang=js&"
import style0 from "./cdn.vue?vue&type=style&index=0&id=5989e7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5989e7f4",
  null
  
)

export default component.exports